import { useEffect } from 'react';
import { useLocation, useNavigate, matchPath } from 'react-router-dom';
import { FC, JSX } from 'react';
import { getAccessToken, getUserInfo } from './localStorage';
import lazyRoutes from '../routes';
import { extractBareRole } from '../constants/appConstants';

interface ProtectedRouteProps {
  component: JSX.Element;
}

const PUBLIC_PATHS = ['/', '/login', '/azureAuth', '/getAToken'];

const ProtectedRoute: FC<ProtectedRouteProps> = ({ component }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;

  const isAuthenticated = getAccessToken();
  const userRoles: string[] = getUserInfo()?.roles || [];
  // Extract bare roles (strip persona prefix) for route authorization
  const bareRoles = userRoles.map(extractBareRole);

  const isPublicRoute = PUBLIC_PATHS.includes(currentPath);

  const matchedRoute = lazyRoutes.find(route => matchPath(route.path, currentPath));

  const isAuthorized = matchedRoute
    ? bareRoles.some(role => matchedRoute.allowedRoles.includes(role))
    : false;

  useEffect(() => {
    if (!isPublicRoute && (!isAuthenticated || userRoles.length === 0)) {
      navigate('/login', { replace: true });
    } else if (!isPublicRoute && matchedRoute && !isAuthorized) {
      navigate(-1);
    } else if (!isPublicRoute && !matchedRoute) {
      navigate(-1);
    }
  }, [
    isPublicRoute,
    isAuthenticated,
    userRoles,
    matchedRoute,
    isAuthorized,
    navigate,
  ]);

  return component;
};

export default ProtectedRoute;